import React from 'react';
import { FEATURES, PRODUCT_REVEAL } from '../constants/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function WhatYouGet() {
  return <section className="w-full bg-white py-12 b760:py-16" data-id="element-266" data-mp="l3l4yexigz3a">
      <div className="mx-auto max-w-4xl px-4 b720:px-6" data-id="element-267" data-mp="l56128zh4q39">
        <Reveal className="text-center" data-id="element-268" data-mp="q1mo0zuxsyer">
          <span className="font-display text-base font-600 uppercase tracking-[0.18em] text-bordo" data-id="element-269" data-mp="q2oae0hel7bs">
            {PRODUCT_REVEAL.kicker}
          </span>
          <h2 className="mt-2 font-display text-3xl font-700 uppercase leading-none text-night b640:text-5xl" data-id="element-270" data-mp="1irmyrfc4d5pj">
            {PRODUCT_REVEAL.name}
          </h2>
          <p className="mx-auto mt-3 max-w-xl font-display text-base font-500 text-bordo b640:text-lg" data-id="element-271" data-mp="1404gtbzp913j">
            {PRODUCT_REVEAL.tagline}
          </p>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-night/85 b640:text-base" data-id="element-272" data-mp="1wptkxy7phh9d">
            {PRODUCT_REVEAL.promise}
          </p>
        </Reveal>

        <Reveal className="mx-auto mt-10 max-w-2xl text-center" data-id="element-273" data-mp="2vfkf0vkhhmk8">
          <p className="font-display text-xl font-700 text-night b640:text-2xl" data-id="element-274" data-mp="2vdpv9kky80hq">
            {PRODUCT_REVEAL.question}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-night/80 b640:text-base" data-id="element-275" data-mp="355ditaedwxdx">
            {PRODUCT_REVEAL.answer}
          </p>
        </Reveal>

        <div className="mt-10 space-y-5" data-id="element-276" data-mp="30dc5dl5hd0mb">
          {FEATURES.map((feature, index) => <Reveal key={feature.tag} delay={index * 60} data-id="element-277" data-mp="3e4qr3zqrvfx2" data-mpi={index}>
              <article className="overflow-hidden rounded-2xl border border-night/10 bg-cream" data-id="element-278" data-mp="397qlfpxu4f6h">
                <img src={feature.img} alt={feature.title} width={900} height={675} loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-279" data-mp="3o47z4nthy5w7" />
                <div className="p-5 b640:p-7" data-id="element-280" data-mp="1orx0tg56vw4p">
                <span className="inline-block rounded-full bg-bordo px-3 py-1 text-[11px] font-700 uppercase tracking-wide text-cream b640:text-xs" data-id="element-281" data-mp="1ot865kea9bxx">
                  {feature.tag}
                </span>
                <h3 className="mt-3 font-display text-xl font-700 uppercase leading-tight text-night b640:text-2xl" data-id="element-282" data-mp="2ihea8vd8ijwh">
                  {feature.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-night/85 b640:text-base" data-id="element-283" data-mp="2sg3hzvbf2nz0">
                  {feature.body}
                </p>
                <p className="mt-4 flex gap-2 rounded-lg border-l-4 border-mustard bg-white px-4 py-3 text-sm leading-relaxed text-night/80 b640:text-base" data-id="element-284" data-mp="2xckg9icbyipt">
                  <span className="shrink-0 font-700 text-mustard-dark" aria-hidden="true" data-id="element-285" data-mp="36806zqhsghr6">
                    ✓
                  </span>
                  <span data-id="element-286" data-mp="3g666k1g4hbsv">{feature.note}</span>
                </p>
                </div>
              </article>
            </Reveal>)}
        </div>

        <Reveal className="mx-auto mt-10 max-w-md" data-id="element-287" data-mp="19gmaqdyfc24m">
          <CtaButton data-id="element-288" data-mp="19i79kfrru78a">{PRODUCT_REVEAL.cta}</CtaButton>
          <p className="mt-2 text-center text-xs text-night/60 b640:text-sm" data-id="element-289" data-mp="14hsy0nqyof5i">
            {PRODUCT_REVEAL.ctaSub}
          </p>
        </Reveal>
      </div>
    </section>;
}